import React, { useMemo } from "react";
import {
  Link,
  NavigationSidebar,
  TreeNode,
  TreeView,
  useSidebarCollapsed,
} from "@sscs/ui";
import {
  APPEARANCE_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  PERSONAL_ACCESS_TOKEN_ROUTE,
  PROFILE_ROUTE,
} from "Constants";

type SettingsNavigation = {
  selected: string;
  onClick: (selected: string) => void;
  hideChangePasswordLink: boolean;
};

const SettingsNavigation = ({
  selected,
  onClick,
  hideChangePasswordLink,
}: SettingsNavigation): React.JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useSidebarCollapsed("user-settings");

  const nodes = useMemo<TreeNode[]>(() => {
    const item = (
      route: string,
      id: string,
      text: string,
      short: string,
    ): TreeNode => ({
      id: route,
      label: (
        <Link to={route}>
          <span id={id}>{text}</span>
        </Link>
      ),
      shortLabel: (
        <Link to={route}>
          <span>{short}</span>
        </Link>
      ),
    });

    return [
      item(PROFILE_ROUTE, "user-details", "Profile", "Profile"),
      ...(hideChangePasswordLink
        ? []
        : [
            item(
              CHANGE_PASSWORD_ROUTE,
              "change-password",
              "Change password",
              "Password",
            ),
          ]),
      item(
        PERSONAL_ACCESS_TOKEN_ROUTE,
        "personal-access-tokens",
        "Personal access tokens",
        "Tokens",
      ),
      item(APPEARANCE_ROUTE, "appearance", "Appearance", "Theme"),
    ];
  }, [hideChangePasswordLink]);

  return (
    <NavigationSidebar
      aria-label="settings-navigation"
      storageKey="user-settings"
      title="Settings"
      isCollapsed={isCollapsed}
      onCollapse={setIsCollapsed}
    >
      <TreeView selected={selected} onChange={onClick} nodes={nodes} />
    </NavigationSidebar>
  );
};

export default SettingsNavigation;
